module.exports = new __parcel__URL__("inquiry_zh-cn.a9fe0559.webp").toString();